import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const cultureSlice = createSlice({
  name: "culture",
  initialState,
  reducers: {
    // create
    createCultureStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    createCultureSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    createCultureFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetCreateCultureState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // update
    updateCultureStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    updateCultureSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    updateCultureFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetUpdateCultureState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // delete
    deleteCultureStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    deleteCultureSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    deleteCultureFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetDeleteCultureState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  createCultureStart,
  createCultureSuccess,
  createCultureFailure,
  resetCreateCultureState,
  updateCultureStart,
  updateCultureSuccess,
  updateCultureFailure,
  resetUpdateCultureState,
  deleteCultureStart,
  deleteCultureSuccess,
  deleteCultureFailure,
  resetDeleteCultureState,
} = cultureSlice.actions;

export default cultureSlice.reducer;
